import { useQuery } from '@tanstack/react-query';
import getRulesetList from 'Api/schedule-ruleset/getRulesetList';
import { getRulesetListRequest } from './model/request/getRulesetListRequest';
import getRulesetListResponse from './model/response/getRulesetListResponse';

const useGetRulesetList = (queryParams) => {
  return useQuery({
    queryKey: ['ruleset-list', queryParams],
    queryFn: async () => {
      const queries = getRulesetListRequest(queryParams);

      const response = await getRulesetList(queries);

      const result = getRulesetListResponse(response);

      return result;
    },
    refetchOnWindowFocus: false,
    retry: false,
    gcTime: 0,
  });
};

export default useGetRulesetList;
